import { render, staticRenderFns } from "./LinkDataForm.vue?vue&type=template&id=05a67339&scoped=true&"
import script from "./LinkDataForm.vue?vue&type=script&lang=js&"
export * from "./LinkDataForm.vue?vue&type=script&lang=js&"
import style0 from "./LinkDataForm.vue?vue&type=style&index=0&id=05a67339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a67339",
  null
  
)

export default component.exports